import { Injectable } from '@angular/core';
import { CourierModel } from './courier-model';
import { Observable, EMPTY } from 'rxjs';
import { MdlDialogReference, IMdlCustomDialogConfiguration, MdlDialogService, MdlSnackbarComponent } from '@angular-mdl/core';
import { CourierModelComponent, COURIER_MODEL_TOKEN } from './courier-model.component';
import { switchMap, map, catchError } from 'rxjs/operators';
import { GlobalErrorHandler } from '../../core/global-error-handler';

@Injectable()
export class CourierModelDialogService {

    private snackBar: Observable<MdlSnackbarComponent>;

    constructor(
        private globalErrorHandler: GlobalErrorHandler,
        private dialogService: MdlDialogService) {
    }

    public showCourierDetailsDialog(courierShipmentId: string, shipmentStatus: string, numberOfSamples: string, isSponsorModel = false) {
        if (!shipmentStatus) { return null; }
        let courierModel: CourierModel = {
            lgxCourierShipmentId: courierShipmentId,
            numberOfSamples: numberOfSamples,
            shipmentStatus: shipmentStatus,
            isSponsorModel: isSponsorModel
        };
        return this.showDialog(courierModel)
            .pipe(
                switchMap(dialog => dialog.onHide()),
                map(dialogResult => dialogResult),
                catchError(error => {
                    this.showNoDataText();
                    return EMPTY;
                })).subscribe();
    }

    private showDialog(courierModel: CourierModel): Observable<MdlDialogReference> {
        const configDialog: IMdlCustomDialogConfiguration = {
            component: CourierModelComponent,
            providers: [{
                provide: COURIER_MODEL_TOKEN, useValue: courierModel
            }],
            isModal: true,
            classes: 'sr-dialog',
            styles: { 'width': '70%' },
            clickOutsideToClose: false
        };

        return this.dialogService.showCustomDialog(configDialog);
    }


    private showNoDataText() {
        let customAction = { handler: () => this.closeSnackbar(), text: 'DISMISS', isClosingAction: true };
        this.snackBar = this.globalErrorHandler.displayErrorMsg('Due to a technical issue, this data is not currently available. Please contact us.', customAction);
        return;
    }

    private  closeSnackbar() {
        if (!this.snackBar) { return; }
        this.snackBar.subscribe(t => t.hide());
    }

}